import React, { Component } from 'react';
import { Grid, Row, PageHeader } from 'react-bootstrap';
import {withRouter} from 'react-router-dom'
import Crummy from "../Components/Crummy";

class Artwork extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loaded: true
    };
  }



  componentWillUpdate() {
    // console.log('component about to update!');
  }

  breadcumb() {
    return (
      <Crummy paths={[{'name': 'Home', 'path': '/'},]} page={'Artwork'}/>
    );
  }

  render() {


    if (this.state.loaded === false) {
      return (
        <Grid>
          {this.breadcumb()}
          <Row>
            <PageHeader>Artwork</PageHeader>
          </Row>
          <Row>
            <div>
              <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            </div>
          </Row>
        </Grid>
      )
    }

    return (
        <Grid>
          {this.breadcumb()}
          <Row>
            <PageHeader>Artwork</PageHeader>
          </Row>
          <Row>
            Artwork Page
          </Row>
        </Grid>
    );
  }
}
export default withRouter(Artwork);



// WEBPACK FOOTER //
// ./src/pages/Artwork.jsx